import React from 'react';
import { PipelineTrackEditor } from '../components/PipelineTrackEditor';

function DeliveryModelPage() {
  return (
    <div className="deliveryModelPage">
      <PipelineTrackEditor />
    </div>
  );
}

export { DeliveryModelPage };
